import React from 'react';
import { Button, Card } from 'antd';

const icons = {
  list: 'align-left',
  text: 'font-colors',
  location: 'environment',
};

export const SelectType = ({ toggle, types, displayForm }) => (
  <Card
    title="Choisissez le type de champs à ajouter"
    className="add-control-select"
    extra={(
      <Button
        onClick={toggle}
        type="danger"
        icon="stop"
      >
          Annuler
      </Button>
    )}
  >
    <div className="add-control-select__content">
      {types.map(type => (
        <Button
          key={type.type}
          icon={icons[type.type]}
          className="add-control-select__button"
          onClick={displayForm(type)}
        >
          {type.label}
        </Button>
      ))}
    </div>
  </Card>
);

export default SelectType;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/AddControl/SelectType.js